/**
 * Scroll-linked parallax inside #hero: text, product visual, and lens flares
 * move at slightly different rates for depth. Disabled when prefers-reduced-motion.
 */
export function initHeroScrollParallax() {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const hero = document.getElementById('hero');
  if (!hero) return;

  const text = hero.querySelector('.hero-text');
  const visual = hero.querySelector('.hero-visual');
  const flares = hero.querySelectorAll('.lens-flare');

  let ticking = false;

  function update() {
    const rect = hero.getBoundingClientRect();
    const vh = window.innerHeight || 800;
    // 0 while hero top is at/below viewport top-ish; ramps toward 1 as hero scrolls up
    const t = Math.max(0, Math.min(1, -rect.top / (vh * 0.72)));

    const maxVisual = Math.min(40, vh * 0.048);
    const maxText = maxVisual * 0.48;
    const maxFlare = maxVisual * 0.36;

    if (visual) {
      visual.style.transform = `translate3d(0, ${t * maxVisual}px, 0)`;
    }
    if (text) {
      text.style.transform = `translate3d(0, ${-t * maxText}px, 0)`;
    }

    flares.forEach((flare, i) => {
      const dir = i % 2 === 0 ? 1 : -1;
      flare.style.transform = `translate3d(0, ${t * maxFlare * dir}px, 0)`;
    });

    ticking = false;
  }

  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  update();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });
}
